import React, { FunctionComponent, useContext } from 'react';

import { ButtonProps } from '../../../../../../shared/components/button';
import { ChatButton } from '../../../chat';
import { CollapseBreakpoint } from '../../constants';
import { ToolbarContext } from '../../index';

export type Props = {
    onClick: () => void;
    disabled?: boolean;
    chatMessagesCount?: number;
    buttonProps?: ButtonProps[];
    visible: boolean;
    collapseBreakpoint?: CollapseBreakpoint;
};

export const ToolbarChatButton: FunctionComponent<Props> = ({
    onClick,
    disabled,
    chatMessagesCount,
    buttonProps,
    visible,
    collapseBreakpoint,
}) => {
    const { buttonSize } = useContext(ToolbarContext);

    return visible ? (
        <ChatButton
            onClick={onClick}
            disabled={disabled}
            chatMessagesCount={chatMessagesCount}
            buttonSize={buttonSize}
            buttonProps={buttonProps}
            collapseBreakpoint={collapseBreakpoint}
        />
    ) : null;
};
